import { toast } from '@navi/web-ui/lib/primitives/Toast';

const fetchDocumentFromS3 = async (dataUrl: string): Promise<Blob> => {
  try {
    const response = await fetch(dataUrl, { cache: 'no-store' });
    const dataBlob = await response.blob();
    return dataBlob;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const downloadDocumentFromS3WithoughtPreview = async (
  url: string,
  fileName: string,
  errorMessage?: string
) => {
  try {
    const dataBlob = await fetchDocumentFromS3(url);
    const dataUrl = URL.createObjectURL(dataBlob);
    const save = document.createElement('a');
    save.href = dataUrl;
    save.download = fileName;
    save.target = '_blank';
    document.body.appendChild(save);
    save.click();
    document.body.removeChild(save);
  } catch (err) {
    errorMessage && toast(errorMessage, { type: 'error' });
  }
};
